import Tooltip from './Tooltip';

export default Tooltip;


//////////////////
// WEBPACK FOOTER
// ../rc-tooltip/es/index.js
// module id = 575
// module chunks = 22